import { RatingData } from '@/components/TeachModel/FeedbackTable';
import { MessageDetailInfo, ratingType } from '@mygpt/types';

/**
 * 获取评分类型
 */
export const getRatingType = (rating: ratingType) => {
  if (rating === 2) return 'good';
  if (rating === -1) return 'bad';
  return undefined;
};

/**
 * 将反馈原因转换为多语言文本
 */
export const getRatingReasonText = (
  ratingData: RatingData[],
  feedbackCheckboxs: Record<string, Array<{ value: string; label: string }>>
): string => {
  if (!ratingData.length) return '-';

  const translatedTexts = ratingData
    .filter((rating) => rating.text) // 过滤掉空文本
    .map((rating) => {
      const type = rating.type;
      const checkbox = feedbackCheckboxs[type];
      if (checkbox) {
        const item = checkbox.find((item) => item.value === rating.text);
        return item ? item.label : rating.text;
      }
      return rating.text;
    });

  return translatedTexts.length ? translatedTexts.join(' | ') : '-';
};

/**
 * 从消息详情中提取反馈原因的多语言文本（用于 Conversation 组件）
 */
export const getRatingReasonFromMessage = (
  messageDetail: MessageDetailInfo,
  feedbackCheckboxs: Record<string, Array<{ value: string; label: string }>>
): string => {
  const type = getRatingType(messageDetail.rating);
  if (!type || !messageDetail.session_message_metadata?.length) return '-';

  const ratingTextList = messageDetail.session_message_metadata
    .filter((meta) => meta.key === 'value')
    .flatMap((meta) => {
      // 防御：meta.value 可能为 null，或为非法 JSON，避免整批导出崩溃
      if (!meta.value) return [];
      let value: unknown;
      try {
        value = JSON.parse(meta.value.replace(/'/g, '"'));
      } catch (e) {
        console.warn('Failed to parse session_message_metadata, skipped:', meta.value, e);
        return [];
      }
      if (!Array.isArray(value)) return [];
      return value.map((metaValue: string) => {
        const checkbox = feedbackCheckboxs[type];
        const item = checkbox?.find((item) => item.value === metaValue);
        return item?.label || metaValue;
      });
    });

  return ratingTextList.length ? ratingTextList.join(' | ') : '-';
};
